// extracted by mini-css-extract-plugin
export default {"tile-row":"_5THG75jYJv","tileRow":"_5THG75jYJv","tile-column":"r0A2YU838F","tileColumn":"r0A2YU838F","webhook-tile":"RYQLqfBW4h","webhookTile":"RYQLqfBW4h","name":"Slip+SGgJC","description":"w5L-mWyvtv","logo":"-SYJp8SBoK"};
    if(module.hot) {
      // 1648553821294
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  